import { action, observable } from 'mobx';
import { api, config } from '../config';

// Components
import SessionStore from './SessionStore';

let obx = observable({
  settings: {},
  userSettings: null,
  // Get user settings
  getUserSettings: action(function(component){
    SessionStore.startLoading('Loading…', 'GetUserSettings');

    api.get(`/proctors/${SessionStore.userData.proctorAccountSid}`)
      .then(response => {
        obx.userSettings = response.data;

        if(component) {
          component.setState({
            proctorTypes: response.data.proctorTypes
          });
        }

        if(component && response.data.image) {
          component.setState({
            existingImage: [response.data.image]
          });
        }

        SessionStore.finishLoading('GetUserSettings');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Update user settings data
  updateUserData: action(function(data) {
    let newData = null;

    for(let key in data) {
      if(key) {
        newData = data[key];
        obx.userSettings[key] = newData;
      }
    }
  }),
  // Update user settings API call
  updateUserSettings: action(function(func){
    SessionStore.startLoading('Loading…', 'UpdateUserSettings');

    if(!obx.userSettings.active) {
      delete obx.userSettings.firstName;
      delete obx.userSettings.lastName;
      delete obx.userSettings.email;
    }

    // Make sure testing administrator cannot be selected
    const taIndex = obx.userSettings.proctorTypes.indexOf(config.testingAdministratorSid);

    if(taIndex > -1) {
      obx.userSettings.proctorTypes.splice(taIndex, 1);
    }

    // Make sure general public cannot be selected
    const gpIndex = obx.userSettings.proctorTypes.indexOf(config.generalPublicSid);

    if(gpIndex > -1) {
      obx.userSettings.proctorTypes.splice(gpIndex, 1);
    }

    // Remove unnecessary data
    Object.keys(obx.userSettings).map(
      (key) => {
        if(
          key !== 'accountName' &&
          key !== 'proctorTypes' &&
          key !== 'password' &&
          key !== 'active' &&
          key !== 'acceptWrittenExams'
        ) {
          delete obx.userSettings[key];
        }

        return true;
      }
    );

    api.put(`/proctors/${SessionStore.userData.proctorAccountSid}`, obx.userSettings)
      .then(response => {
        SessionStore.profile = response.data;
        setTimeout(function(){
          obx.getUserSettings();
          SessionStore.finishLoading('UpdateUserSettings');
          func();
        });
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Toggle setting
  toggleSetting: action(function(data, property){
    data[property] = !data[property];

    // Remove unnecessary data
    Object.keys(data).map(
      (key) => {
        if(
          key !== 'accountName' &&
          key !== 'proctorTypes' &&
          key !== 'password' &&
          key !== 'active' &&
          key !== 'acceptWrittenExams'
        ) {
          delete data[key];
        }

        return true;
      }
    );

    api.put(`/proctors/${SessionStore.userData.proctorAccountSid}`, data)
      .then(response => {
        SessionStore.profile = response.data;
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Update profile photo
  updateProfilePhoto: action(function(data, callback, component){
    SessionStore.startLoading('Loading…', 'UpdateProfilePhoto');

    let formData = new FormData();
    formData.append('image', data.image);

    api.put(`/proctors/${SessionStore.userData.proctorAccountSid}/image`, formData)
      .then(response => {
        SessionStore.finishLoading('UpdateProfilePhoto');

        obx.getUserSettings(component);

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Delete profile photo
  deleteProfilePhoto: action(function(callback) {
    SessionStore.startLoading('Loading…', 'DeleteProfilePhoto');

    api.delete(`/proctors/${SessionStore.userData.proctorAccountSid}/image`)
      .then(response => {
        SessionStore.finishLoading('DeleteProfilePhoto');

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Update password
  updatePassword: action(function(data, callback, proctorAccountSid, proctorUserSid) {
    SessionStore.startLoading('Loading…', 'UpdatePassword');
    
    let accountSid = proctorAccountSid;
    let userSid = proctorUserSid;

    if(!accountSid) {
      accountSid = SessionStore.userData.proctorAccountSid;
    }

    if(!userSid) {
      userSid = SessionStore.userData.sid;
    }

    api.put(`/proctors/${accountSid}/users/${userSid}/password`, data)
      .then(response => {
        if(callback) {
          callback();
        }

        if(SessionStore.userData) {
          SessionStore.userData.forcePasswordReset = false;
        }

        if(SessionStore.hasSessionStorage) {
          sessionStorage.setItem('passwordReset', 'true');
        } else {
          document.cookie = `passwordReset=true`;
        }

        SessionStore.finishLoading('UpdatePassword');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Trigger pasword reset
  resetPassword: action(function(email, callback) {
    SessionStore.startLoading('Loading…', 'ResetPassword');

    const data = {
      emailAddress: email,
      domain: 'proctor.smarterproctoring.com'
    }

    api.post(`/proctors/resetPassword`, data)
      .then(response => {
        if(callback) {
          callback();
        }

        SessionStore.finishLoading('ResetPassword');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  })
});

export default obx;



// WEBPACK FOOTER //
// ./src/app/stores/SettingsStore.js